// https://github.com/orgs/react-hook-form/discussions/1991#discussioncomment-31308
// Map RHF's dirtyFields over the `data` received by `handleSubmit` and return the changed subset of that data.
export function dirtyValues(dirtyFields: object | boolean, allValues: object): object {
  // If *any* item in an array was modified, the entire array must be submitted, because there's no way to indicate
  // "placeholders" for unchanged elements. `dirtyFields` is `true` for leaves.
  if (dirtyFields === true || Array.isArray(dirtyFields)) return allValues;

  // Here, we have an object
  const entries = Object.entries(dirtyFields)
    .map(([key, dirty]) => {
      const value = dirtyValues(dirty, allValues[key]);
      return [key, value];
    })
    .filter(([, value]) => value !== null);

  return entries.length > 0 ? Object.fromEntries(entries) : null;
}
